import {ContextMenuItem} from "./context-menu-item";

export class ContextMenuSeparator extends ContextMenuItem {
  constructor() {
    super(null, null, null, null, true);
  }
}
